import type React from "react";
import { memo } from "react";
import { Button } from "@/components/ui/button";
import type { SearchResultLoadMoreButtonProps } from "@/features/study-group-stream/utils/streamSearchResultTypes";

const DEFAULT_LOAD_MORE_BUTTON_CLASS =
  "rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 disabled:opacity-50";
const DEFAULT_LOAD_MORE_CONTAINER_CLASS = "flex justify-center py-3";

const SearchResultLoadMoreButtonRaw: React.FC<
  SearchResultLoadMoreButtonProps
> = ({
  isLoading,
  onLoadMore,
  loadingLabel,
  label,
  disabled,
  className = DEFAULT_LOAD_MORE_BUTTON_CLASS,
  containerClassName = DEFAULT_LOAD_MORE_CONTAINER_CLASS,
}) => (
  <div className={containerClassName}>
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onLoadMore}
      disabled={disabled}
      className={className}
      aria-busy={isLoading}
    >
      {isLoading ? loadingLabel : label}
    </Button>
  </div>
);

export const StreamSearchLoadMoreButton = memo(SearchResultLoadMoreButtonRaw);
StreamSearchLoadMoreButton.displayName = "StreamSearchLoadMoreButton";
